<div *ngIf="editForm" class="ir-area ir-mask th-mask">
  <form class="ir-modal th-modal" novalidate="" [formGroup]="editForm" (ngSubmit)="save(editForm.value)">
    <modal-header [plugin]="plugin" [menuModal]="menuModal"></modal-header>
    <div class="ir-modal--body has-footer ir-pv8 ir-ph8">
      <div class="ir-content--modal th-content">
        <table class="ir-modal-table">
          <tr>
            <td class="margin-big">
              <h2>
                <span>{{ 'plugins.installation-inspection-info.start-date' | translate }}</span>
              </h2>
            </td>
            <td class="margin">
              <div class="ir-form-group">
                <input
                  type="date"
                  name="StartDate"
                  class="ir-form-set"
                  [max]="editForm.controls.EndDate.value | inputDate"
                  formControlName="StartDate"
                />
              </div>
            </td>
          </tr>
          <tr>
            <td class="margin-big">
              <h2>
                <span>{{ 'plugins.installation-inspection-info.end-date' | translate }}</span>
              </h2>
            </td>
            <td class="margin">
              <div class="ir-form-group">
                <input
                  type="date"
                  name="EndDate"
                  class="ir-form-set"
                  [min]="editForm.controls.StartDate.value | inputDate"
                  formControlName="EndDate"
                />
              </div>
            </td>
          </tr>
          <!-- <tr>
            <td class="margin-big">
              <h2>
                <span>{{ 'plugins.installation-inspection-info.intervention-type' | translate }}</span>
              </h2>
            </td>
            <td class="margin">
              <div class="ir-form-group">
                <input type="hidden" name="InterventionType" class="ir-form-set" formControlName="InterventionType" />
                <div class="ir-line ir-select th-select" (click)="openSubTypeSelector()">
                  <div class="ir-line--right">
                    <div class="ir-btn th-btn-modal--content">
                      <i class="material-icons">arrow_drop_down</i>
                    </div>
                  </div>
                  <div class="ir-line-content">
                    <span>{{
                      editForm.controls.InterventionType.value
                        ? (editForm.controls.InterventionType.value | subType)
                        : ('common.please-select' | translate)
                    }}</span>
                  </div>
                </div>
              </div>
            </td>
          </tr> -->
        </table>
      </div>
    </div>
    <modal-footer [editForm]="editForm" [processing]="processing"></modal-footer>
  </form>
</div>

<modal (modalOutput)="selectSubTypeMenu($event)" (modalClosed)="onSubTypeMenuClose()" #subTypeModal></modal>
<modal #menuModal (modalOutput)="selectMenu($event)"></modal>
<confirm
  #pluginDeleteConfirm
  (confirmOutput)="deletePlugin()"
  [title]="'common.delete-confirmation' | translate"
  [message]="'plugins.sure-to-delete' | translate"
  [danger]="true"
></confirm>
